import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { message } from "antd";
import { resetUserPassword } from "src/services/AuthenticationAPIs";

const Resetpassword: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [new_password, setNewPassword] = useState<string>("");

  // Validation states
  const [lengthCheck, setLengthCheck] = useState<boolean>(false);
  const [numCheck, setNumCheck] = useState<boolean>(false);
  const [capitalCheck, setCapitalCheck] = useState<boolean>(false);
  const [charCheck, setCharCheck] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const checkPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNewPassword(value);

    // Validation checks
    setLengthCheck(value.length >= 8);
    setCharCheck(/[!@#$%^&*]/.test(value));
    setNumCheck(/[0-9]/.test(value));
    setCapitalCheck(/[A-Z]/.test(value));
  };

  const handleUpdatePassword = async (
    e: React.FormEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();

    if (!lengthCheck || !charCheck || !numCheck || !capitalCheck) {
      message.error("Please meet all password requirements before proceeding.");
      return;
    }

    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      message.error("Invalid or missing reset token. Please try again.");
      return;
    }

    try {
      const data = await resetUserPassword({
        token,
        newPassword: new_password,
      });

      if (data.status) {
        message.success(data.message || "Password updated successfully!");
        setTimeout(() => navigate("/log-in"), 3000);
      } else {
        message.error(
          data.message || "Failed to update password. Please try again."
        );
      }
    } catch {
      message.error("Unable to connect to the server. Please try again later.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };
  return (
    <>
      <div className="reset-pass-bg" style={{ backgroundImage: `url(/Icons/forget-password-bg.svg)` }}>
        <img src="/images/DpLogo.png" className="logo-design" alt="img" />
        <div className="app">
          <div className="signup-internal-container">
            <form className="formdesign">
              <img src="/Icons/open-lock-reset-pass.svg" className="open-lock" alt="userlock" />
              <h2 className="Reset-password">Reset Password</h2>
              <p className="Reset-detail">
                Create your new password and save below.
              </p>
              <div className="password-field">
                <label>
                  Create Password
                  <div className="password-input-container">
                    <input
                      value={new_password}
                      onChange={checkPassword}
                      type={showPassword ? "text" : "password"}
                    />
                    <div
                      className={"eye-icon"}
                      onClick={() => togglePasswordVisibility()}
                    >
                      {showPassword ? (
                        <img src="/Icons/open eye.svg" alt="Hide password" />
                      ) : (
                        <img src="/Icons/close eye.svg" alt="Show password" />
                      )}
                    </div>
                  </div>
                </label>
              </div>

              <div className="password-msgs">
                <div className="condition-row">
                  {lengthCheck ? (
                    <CheckCircleFilled className="tick-filled-icon" />
                  ) : (
                    <CloseCircleFilled className="cross-filled-icon" />
                  )}
                  <span
                    className={`condition-txt ${
                      lengthCheck ? "valid-msg" : "invalid-msg"
                    }`}
                  >
                    Must be at least 8 characters
                  </span>
                </div>
                <div className="condition-row">
                  {charCheck ? (
                    <CheckCircleFilled className="tick-filled-icon" />
                  ) : (
                    <CloseCircleFilled className="cross-filled-icon" />
                  )}
                  <span
                    className={`condition-txt ${
                      charCheck ? "valid-msg" : "invalid-msg"
                    }`}
                  >
                    Must contain at least 1 special character
                  </span>
                </div>
                <div className="condition-row">
                  {numCheck ? (
                    <CheckCircleFilled className="tick-filled-icon" />
                  ) : (
                    <CloseCircleFilled className="cross-filled-icon" />
                  )}
                  <span
                    className={`condition-txt ${
                      numCheck ? "valid-msg" : "invalid-msg"
                    }`}
                  >
                    Must contain at least 1 number
                  </span>
                </div>
                <div className="condition-row">
                  {capitalCheck ? (
                    <CheckCircleFilled className="tick-filled-icon" />
                  ) : (
                    <CloseCircleFilled className="cross-filled-icon" />
                  )}
                  <span
                    className={`condition-txt ${
                      capitalCheck ? "valid-msg" : "invalid-msg"
                    }`}
                  >
                    Must contain at least 1 capital letter
                  </span>
                </div>
              </div>

              <button
                style={{ marginTop: "2rem" }}
                onClick={e => handleUpdatePassword(e)}
                className="button"
              >
                Update Password
              </button>

              <p className="signup-page-text viewTerms_text">
                Remember your password?&nbsp;
                <a href="/log-in">Sign In</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resetpassword;
